import { render, staticRenderFns } from "./EmployeeLogin.vue?vue&type=template&id=203fcbfc&"
import script from "./EmployeeLogin.vue?vue&type=script&lang=js&"
export * from "./EmployeeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports